// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ePWI","right":"styles_right__3Tx_R"};